import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconMall"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4V20H22V4H2ZM13 11H16V18H13V11ZM11 11H8V18H11V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMall;
